module.exports = __webpack_public_path__ + "img/IN.f2a2822c.jpg";